/**
 * Enum specifying all the possible "role"/"meaning" of the Measurements of "ELECTRIC"-counter SmartComponent.
 */
export enum ElectricCounterMeasurementType {
    NONE = 0,
    ELECTRIC_ENERGY_ABSORBED_LAST_MONTH = 1,
    ELECTRIC_ENERGY_ABSORBED_PREVIOUS_MONTH = 2,
    ELECTRIC_ENERGY_ABSORBED_LAST_YEAR = 3,
    ELECTRIC_ENERGY_ABSORBED_PREVIOUS_YEAR = 4,
    ELECTRIC_ENERGY_PRODUCED_LAST_MONTH = 5,
    ELECTRIC_ENERGY_PRODUCED_PREVIOUS_MONTH = 6,
    ELECTRIC_ENERGY_PRODUCED_LAST_YEAR = 7,
    ELECTRIC_ENERGY_PRODUCED_PREVIOUS_YEAR = 8,
    ELECTRIC_ACTIVE_POWER = 9,
    ELECTRIC_POWER_EXCHANGE_LAST_MONTH = 10,
    ELECTRIC_POWER_EXCHANGE_PREVIOUS_MONTH = 11,
    ELECTRIC_POWER_EXCHANGE_LAST_YEAR = 12,
    ELECTRIC_POWER_EXCHANGE_PREVIOUS_YEAR = 13,
}


/**
 * Enum specifying all the possible "role"/"meaning" of the Measurements of "GAS"-counter SmartComponent.
 */
export enum GasCounterMeasurementType {
    NONE = 0,
    GAS_VOLUME_LAST_MONTH = 1,
    GAS_VOLUME_PREVIOUS_MONTH = 2,
    GAS_VOLUME_LAST_YEAR = 3,
    GAS_VOLUME_PREVIOUS_YEAR = 4
}

/**
 * Enum containing the various types of measurement of an hot or cold water meter
 */
export enum WaterCounterMeasurementType {
    NONE = 0,
    WATER_FLOW = 1,
    WATER_VOLUME_LAST_MONTH = 2,
    WATER_VOLUME_PREVIOUS_MONTH = 3,
    WATER_VOLUME_LAST_YEAR = 4,
    WATER_VOLUME_PREVIOUS_YEAR = 5

}

/**
 * Enum specifying all the possible "role"/"meaning" of the Measurements of "HEATING"-counter SmartComponent.
 */
export enum HeatingCounterMeasurementType {
    NONE = 0,
    HEAT_THERMAL_ENERGY_LAST_MONTH = 1,
    HEAT_THERMAL_ENERGY_PREVIOUS_MONTH = 2,
    HEAT_THERMAL_ENERGY_LAST_YEAR = 3,
    HEAT_THERMAL_ENERGY_PREVIOUS_YEAR = 4,
    HEAT_VOLUME_LAST_MONTH = 5,
    HEAT_VOLUME_PREVIOUS_MONTH = 6,
    HEAT_VOLUME_LAST_YEAR = 7,
    HEAT_VOLUME_PREVIOUS_YEAR = 8,
    HEAT_ACTIVE_POWER = 9
}

/**
 * Enum specifying all the possible "role"/"meaning" of the Measurements of "DISTRIBUTOR"-counter SmartComponent.
 */
export enum DistributorCounterMeasurementType {
    NONE = 0,
    DISTRIBUTOR_CONSUMPTION_LAST_MONTH = 1,
    DISTRIBUTOR_CONSUMPTION_PREVIOUS_MONTH = 2,
    DISTRIBUTOR_CONSUMPTION_LAST_YEAR = 3,
    DISTRIBUTOR_CONSUMPTION_PREVIOUS_YEAR = 4
}
